import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Eyebrow, Button, HUDBrackets } from './UI';
import { Truck, Shield, RefreshCw, Lock, ChevronDown, Check, Plus, Minus, Flame, Snowflake, Users } from 'lucide-react';
const lensAddons = [{
  id: 'fire',
  name: 'FIRE MIRROR LENS',
  sub: 'Yellow / Orange Iridium',
  desc: 'High-contrast warm mirror. Sunrise to sunset glare control.',
  price: 9.99,
  icon: <Flame size={18} data-id="element-438" />,
  gradient: 'linear-gradient(135deg, #ffb700 0%, #ff4d00 50%, #c20000 100%)',
  previewSrc: 'https://cdn.magicpatterns.com/uploads/qfpR5MgkLAbeaejKaujYuk/hf_20260506_131314_cebde306-3d2d-4625-a902-2e8e03cbb432.png',
  previewLabel: 'FIRE LENS EQUIPPED'
}, {
  id: 'ice',
  name: 'ICE MIRROR LENS',
  sub: 'Blue / Purple Iridium',
  desc: 'Cold-spectrum mirror. High-altitude UV reduction.',
  price: 9.99,
  icon: <Snowflake size={18} data-id="element-439" />,
  gradient: 'linear-gradient(135deg, #b266ff 0%, #2a6dff 50%, #00c2ff 100%)',
  previewSrc: 'https://cdn.magicpatterns.com/uploads/i83EYvoLKtLaCwpLHgESRH/hf_20260506_130002_0d9ba6fa-3e05-4389-bd70-b9ee2bcc91e4.png',
  previewLabel: 'ICE LENS EQUIPPED'
}];
const specs = [{
  label: 'Shell',
  value: 'Glass-Fiber Reinforced Composite'
}, {
  label: 'Frame',
  value: 'Grade 304 Stainless Steel'
}, {
  label: 'Lens',
  value: 'Lexan Polycarbonate — ANSI Z87.1'
}, {
  label: 'Coating',
  value: 'Anti-Fog Nano + UV400'
}, {
  label: 'Strap',
  value: 'Ballistic Nylon — Dual Adjust'
}, {
  label: 'Weight',
  value: '380g (13.4 oz)'
}, {
  label: 'Fit',
  value: 'Universal — 52cm–62cm'
}, {
  label: 'Ventilation',
  value: '14-Port Dual Mesh'
}];
const gallery = [{
  src: 'https://cdn.magicpatterns.com/uploads/ccNoC1hUfPputXVXttp9ur/hf_20260505_164053_a2220f21-6ee4-4e03-a216-305128115bb2.png',
  alt: 'Mask Field Deployed',
  label: 'FIELD DEPLOYED'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/8wsq1CLQoFFHFK7Ud539GB/hf_20260505_161401_b22ab001-c648-4408-a098-97bb18fba3a3.png',
  alt: 'BLACKOUT UNIT Box',
  label: 'PACKAGING'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ixvSzA9vgFfVZNTHmoz2hu/hf_20260505_160349_8ac9e7f0-517f-4f74-9ee5-49caa262d662.png',
  alt: 'Mask Front',
  label: 'FRONT VIEW'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/wktPfPj4sasfKV5cbuidEQ/hf_20260505_160726_c7d8c9e1-4986-4b8e-9be1-eab15717a38a.png',
  alt: 'Mask Side',
  label: 'SIDE PROFILE'
}];
const bundles = [{
  id: 'duo',
  name: 'DUO STRIKE',
  count: 2,
  price: 43.11,
  badge: null,
  cartUrl: 'https://blackoutunit.com/cart/44427733139549:1'
}, {
  id: 'tricolor',
  name: 'TRI-COLOR SQUAD',
  count: 3,
  price: 76.37,
  badge: 'CUSTOM LENSES',
  desc: '1 Smoke Black + 1 Ice Mirror + 1 Fire Mirror',
  cartUrl: 'https://blackoutunit.com/cart/44425874407517:1'
}, {
  id: 'squad',
  name: 'SQUAD UNIT',
  count: 4,
  price: 101.83,
  badge: 'MOST POPULAR',
  cartUrl: 'https://blackoutunit.com/cart/44427736711261:1'
}, {
  id: 'platoon',
  name: 'PLATOON SIX',
  count: 6,
  price: 114.96,
  badge: 'BEST VALUE',
  cartUrl: 'https://blackoutunit.com/cart/44427736842333:1'
}];
const BASE_PRICE = 29.95;
const COMPARE_PRICE = 69.98;
const SINGLE_MASK_URL = 'https://blackoutunit.com/cart/44424057225309:1';
const DUO_MASK_URL = 'https://blackoutunit.com/cart/44427733139549:1';
const TRIPLE_MASK_URL = 'https://blackoutunit.com/cart/44443902738525:1';
const QUAD_MASK_URL = 'https://blackoutunit.com/cart/44427736711261:1';
const SIX_MASK_URL = 'https://blackoutunit.com/cart/44427736842333:1';
// Single mask + 1 fire mirror lens
const ONE_BLACK_ONE_FIRE_URL = 'https://blackoutunit.com/cart/44424057389149:1';
// Single mask + 1 ice mirror lens
const ONE_BLACK_ONE_ICE_URL = 'https://blackoutunit.com/cart/44424060338269:1';
// Single mask + 1 fire + 1 ice (same SKU as TRI-COLOR SQUAD)
const ONE_BLACK_FIRE_AND_ICE_URL = 'https://blackoutunit.com/cart/44425874407517:1';
// Two masks + 1 fire lens
const TWO_BLACK_ONE_FIRE_URL = 'https://blackoutunit.com/cart/44444222849117:1';
// Two masks + 1 ice lens
const TWO_BLACK_ONE_ICE_URL = 'https://blackoutunit.com/cart/44444223438941:1';
// Two masks + 1 fire + 1 ice
const TWO_BLACK_FIRE_AND_ICE_URL = 'https://blackoutunit.com/cart/44444225339485:1';
// DUO STRIKE bundle + 1 fire lens
const DUO_BUNDLE_ONE_FIRE_URL = 'https://blackoutunit.com/cart/44444241461341:1';
// DUO STRIKE bundle + 1 ice lens
const DUO_BUNDLE_ONE_ICE_URL = 'https://blackoutunit.com/cart/44444245459037:1';
// Resolves the correct Shopify cart URL based on current selection.
// Returns null if no URL is configured for the combination yet.
const resolveCartUrl = (activeBundle: {
  id: string;
  cartUrl: string | null;
} | null, qty: number, addonQty: Record<string, number>): string | null => {
  const fireQty = addonQty.fire ?? 0;
  const iceQty = addonQty.ice ?? 0;
  const totalAddons = fireQty + iceQty;
  // Bundle selected
  if (activeBundle) {
    // Bundle + add-on combinations
    if (totalAddons > 0) {
      // DUO STRIKE + 1 fire lens
      if (activeBundle.id === 'duo' && fireQty === 1 && iceQty === 0) {
        return DUO_BUNDLE_ONE_FIRE_URL;
      }
      // DUO STRIKE + 1 ice lens
      if (activeBundle.id === 'duo' && iceQty === 1 && fireQty === 0) {
        return DUO_BUNDLE_ONE_ICE_URL;
      }
      // Other bundle + addon combinations pending
      return null;
    }
    return activeBundle.cartUrl;
  }
  // Combinations with add-ons
  if (totalAddons > 0) {
    // 1 black mask + 1 fire mirror lens (no ice)
    if (qty === 1 && fireQty === 1 && iceQty === 0) {
      return ONE_BLACK_ONE_FIRE_URL;
    }
    // 1 black mask + 1 ice mirror lens (no fire)
    if (qty === 1 && iceQty === 1 && fireQty === 0) {
      return ONE_BLACK_ONE_ICE_URL;
    }
    // 1 black mask + 1 fire + 1 ice
    if (qty === 1 && fireQty === 1 && iceQty === 1) {
      return ONE_BLACK_FIRE_AND_ICE_URL;
    }
    // 2 black masks + 1 fire lens
    if (qty === 2 && fireQty === 1 && iceQty === 0) {
      return TWO_BLACK_ONE_FIRE_URL;
    }
    // 2 black masks + 1 ice lens
    if (qty === 2 && iceQty === 1 && fireQty === 0) {
      return TWO_BLACK_ONE_ICE_URL;
    }
    // 2 black masks + 1 fire + 1 ice
    if (qty === 2 && fireQty === 1 && iceQty === 1) {
      return TWO_BLACK_FIRE_AND_ICE_URL;
    }
    // Other addon combinations pending
    return null;
  }
  // Single mask
  if (qty === 1) return SINGLE_MASK_URL;
  // Two black masks → same destination as DUO STRIKE
  if (qty === 2) return DUO_MASK_URL;
  // Three black masks with black lenses
  if (qty === 3) return TRIPLE_MASK_URL;
  // Four black masks → same destination as SQUAD UNIT
  if (qty === 4) return QUAD_MASK_URL;
  // Six black masks → same destination as PLATOON SIX
  if (qty === 6) return SIX_MASK_URL;
  // Other quantities pending
  return null;
};
export const Product = () => {
  const [activeImage, setActiveImage] = useState(0);
  const [qty, setQty] = useState(1);
  const [addonQty, setAddonQty] = useState<Record<string, number>>({});
  const [selectedBundle, setSelectedBundle] = useState<string | null>(null);
  const [openAccordion, setOpenAccordion] = useState<string | null>('specs');
  const [lensPreviewId, setLensPreviewId] = useState<string | null>(null);
  const toggleAccordion = (id: string) => {
    setOpenAccordion(openAccordion === id ? null : id);
  };
  const getAddonQty = (id: string) => addonQty[id] ?? 0;
  const changeAddonQty = (id: string, delta: number) => {
    setAddonQty(prev => {
      const current = prev[id] ?? 0;
      const next = Math.max(0, current + delta);
      const updated = {
        ...prev,
        [id]: next
      };
      // When increasing from 0 → preview this lens
      const addon = lensAddons.find(a => a.id === id);
      if (current === 0 && next > 0 && addon?.previewSrc) {
        setLensPreviewId(id);
        if (typeof window !== 'undefined' && window.innerWidth < 1024) {
          const el = document.getElementById('the-mask');
          el?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
      // When dropping to 0 and it was the preview → clear preview
      if (next === 0 && lensPreviewId === id) {
        setLensPreviewId(null);
      }
      return updated;
    });
  };
  const toggleBundle = (id: string) => {
    setSelectedBundle(prev => prev === id ? null : id);
  };
  const activeBundle = bundles.find(b => b.id === selectedBundle) || null;
  const masksSubtotal = activeBundle ? activeBundle.price : BASE_PRICE * qty;
  const maskCount = activeBundle ? activeBundle.count : qty;
  const totalAddons = Object.values(addonQty).reduce((a, b) => a + b, 0);
  const addonsTotal = totalAddons * 9.99;
  const total = masksSubtotal + addonsTotal;
  const savings = (COMPARE_PRICE - BASE_PRICE).toFixed(2);
  const savingsPct = Math.round((COMPARE_PRICE - BASE_PRICE) / COMPARE_PRICE * 100);
  const cartUrl = resolveCartUrl(activeBundle, qty, addonQty);
  const handleDeploy = () => {
    if (cartUrl) {
      window.location.href = cartUrl;
    } else {
      alert('Lógica de carrito para esta combinación pendiente de links.');
    }
  };
  // Dispatch event to update sticky mobile bar
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('priceUpdate', {
        detail: {
          total,
          qty,
          activeBundle,
          addonQty,
          totalAddons,
          cartUrl
        }
      }));
    }
  }, [total, qty, activeBundle, addonQty, totalAddons, cartUrl]);
  return <section id="the-mask" className="bg-base-black pt-[40px] pb-[40px]" data-id="element-440">
      <div className="container mx-auto px-6 md:px-12" data-id="element-441">
        <div className="text-center mb-16" data-id="element-442">
          <Eyebrow data-id="element-443">THE WEAPON</Eyebrow>
          <h2 className="text-5xl md:text-[72px] leading-[0.9] mb-4" data-id="element-444">
            THE BLACKOUT UNIT{' '}
            <span className="text-acid-green" data-id="element-445">ULTIMATE MASK</span>
          </h2>
          <p className="font-barlow text-lg text-text-body" data-id="element-446">
            Configure your unit. Deploy.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] gap-10 lg:gap-16" data-id="element-447">
          {/* Left - Image Gallery (BIGGER) */}
          <div className="w-full" data-id="element-448">
            <div className="lg:sticky lg:top-32" data-id="element-449">
              {/* Main Image */}
              {(() => {
              const previewAddon = lensPreviewId ? lensAddons.find(a => a.id === lensPreviewId) : null;
              const showPreview = !!(previewAddon && previewAddon.previewSrc);
              const displaySrc = showPreview ? previewAddon!.previewSrc as string : gallery[activeImage].src;
              const displayAlt = showPreview ? `Mask equipped with ${previewAddon!.name}` : gallery[activeImage].alt;
              const displayLabel = showPreview ? previewAddon!.previewLabel : gallery[activeImage].label;
              const displayKey = showPreview ? `lens-${lensPreviewId}` : `gallery-${activeImage}`;
              return <div className="relative border border-acid-green/20 bg-dark-1 mb-4 flex justify-center items-center aspect-[4/5] overflow-hidden" data-id="element-450">
                    <HUDBrackets data-id="element-451" />
                    <div className="absolute top-4 left-4 bg-acid-green text-black font-barlow font-bold text-[10px] tracking-[2px] px-3 py-1 z-10" data-id="element-452">
                      BESTSELLER UNIT
                    </div>
                    <div className="absolute top-4 right-4 font-barlow text-[10px] text-acid-green tracking-[2px] z-10 border border-acid-green/40 px-2 py-1 bg-base-black/60" data-id="element-453">
                      {displayLabel}
                    </div>
                    <AnimatePresence mode="wait" data-id="element-454">
                      <motion.img key={displayKey} src={displaySrc} alt={displayAlt} initial={{
                    opacity: 0,
                    scale: 1.02
                  }} animate={{
                    opacity: 1,
                    scale: 1
                  }} exit={{
                    opacity: 0
                  }} transition={{
                    duration: 0.35
                  }} className="w-full h-full object-cover" data-id="element-455" />
                    </AnimatePresence>
                    {showPreview && <button onClick={() => setLensPreviewId(null)} className="absolute bottom-4 right-4 z-20 font-barlow text-[10px] tracking-[2px] uppercase text-white bg-base-black/70 border border-acid-green/40 hover:border-acid-green hover:text-acid-green px-3 py-1 transition-colors" data-id="element-456">
                        ✕ Exit Preview
                      </button>}
                    <div className="absolute bottom-4 left-4 font-barlow text-[10px] text-text-dimmed tracking-[2px] z-10" data-id="element-457">
                      {showPreview ? 'LENS PREVIEW' : `${String(activeImage + 1).padStart(2, '0')} / ${String(gallery.length).padStart(2, '0')}`}
                    </div>
                  </div>;
            })()}

              {/* Thumbnails */}
              <div className="grid grid-cols-4 gap-3" data-id="element-458">
                {gallery.map((img, i) => <button key={i} onClick={() => {
                setActiveImage(i);
                setLensPreviewId(null);
              }} className={`border-2 bg-dark-1 aspect-square overflow-hidden transition-all ${!lensPreviewId && activeImage === i ? 'border-acid-green' : 'border-dark-3 hover:border-white/40'}`} data-id="element-459">
                    <img src={img.src} alt={img.alt} className="w-full h-full object-cover" data-id="element-460" />
                  </button>)}
              </div>
            </div>
          </div>

          {/* Right - Product Info & Configurator */}
          <div className="w-full flex flex-col" data-id="element-461">
            <div className="flex items-center gap-3 font-barlow text-sm tracking-wider mb-4 flex-wrap" data-id="element-462">
              <div className="text-acid-green" data-id="element-463">★★★★★</div>
              <div className="text-white" data-id="element-464">4.9 / 5.0</div>
              <div className="text-text-dimmed" data-id="element-465">|</div>
              <div className="text-text-dimmed" data-id="element-466">(9,273 verified)</div>
              <div className="text-text-dimmed" data-id="element-467">|</div>
              <div className="text-acid-green flex items-center" data-id="element-468">
                <span className="w-2 h-2 bg-acid-green rounded-full mr-2" data-id="element-469"></span>
                IN STOCK
              </div>
            </div>

            <h1 className="font-bebas text-[44px] md:text-[52px] leading-none mb-2" data-id="element-470">
              BLACKOUT UNIT ULTIMATE MASK™
            </h1>
            <p className="font-barlow text-lg text-text-dimmed mb-6" data-id="element-471">
              Full-Face Tactical Protection System
              <br data-id="element-472" />
              Glass-Fiber Composite | Includes Smoke Black Lenses
            </p>

            <div className="flex items-end gap-4 mb-2 pt-2" data-id="element-473">
              <div className="font-bebas text-[56px] text-white leading-none" data-id="element-474">
                ${BASE_PRICE.toFixed(2)}
              </div>
              <div className="font-bebas text-3xl text-text-dimmed line-through leading-none mb-1" data-id="element-475">
                ${COMPARE_PRICE.toFixed(2)}
              </div>
              <div className="bg-acid-green text-black font-barlow font-bold text-xs tracking-[2px] px-2 py-1 mb-2" data-id="element-476">
                SAVE {savingsPct}%
              </div>
            </div>
            <p className="font-inter text-xs text-text-dimmed mb-8 pb-8 border-b border-dark-3" data-id="element-477">
              You save <span className="text-acid-green" data-id="element-478">${savings}</span> per
              unit. Free shipping on all USA orders.
            </p>

            {/* Quantity (now at TOP) */}
            <div className="mb-8" data-id="element-479">
              <div className="font-barlow text-xs text-text-dimmed tracking-widest uppercase mb-3" data-id="element-480">
                ━━ MASK QUANTITY ━━
              </div>
              <div className="flex items-center gap-4" data-id="element-481">
                <div className="flex items-center border border-dark-3" data-id="element-482">
                  <button onClick={() => setQty(Math.max(1, qty - 1))} className="px-4 py-3 text-text-dimmed hover:text-acid-green transition-colors" aria-label="Decrease quantity" data-id="element-483">
                    <Minus size={16} data-id="element-484" />
                  </button>
                  <div className="w-14 text-center font-bebas text-2xl" data-id="element-485">
                    {qty}
                  </div>
                  <button onClick={() => setQty(qty + 1)} className="px-4 py-3 text-text-dimmed hover:text-acid-green transition-colors" aria-label="Increase quantity" data-id="element-486">
                    <Plus size={16} data-id="element-487" />
                  </button>
                </div>
                <p className="font-inter text-xs text-text-dimmed" data-id="element-488">
                  Each unit ships with{' '}
                  <span className="text-white font-bold" data-id="element-489">
                    smoke black lenses
                  </span>{' '}
                  standard.
                </p>
              </div>
            </div>

            {/* Lens Add-Ons / Order Bumps */}
            <div className="mb-8" data-id="element-490">
              <div className="flex items-center gap-3 mb-2" data-id="element-491">
                <div className="font-barlow text-xs text-acid-green tracking-widest uppercase" data-id="element-492">
                  ━━ POWER UP — OPTIONAL LENS ADD-ONS ━━
                </div>
              </div>
              <p className="font-inter text-[12px] text-text-dimmed mb-4" data-id="element-493">
                Add a swappable mirrored lens to your order. Tool-free swap in
                under 30 seconds.
              </p>

              <div className="space-y-3" data-id="element-494">
                {lensAddons.map(addon => {
                const count = getAddonQty(addon.id);
                const active = count > 0;
                return <div key={addon.id} className={`w-full flex items-center gap-4 p-4 border text-left transition-all ${active ? 'border-acid-green bg-acid-green-dim' : 'border-dark-3 bg-dark-1'}`} data-id="element-495">
                      {/* Lens visual — click to preview */}
                      <button type="button" onClick={() => {
                    if (addon.previewSrc) {
                      setLensPreviewId(lensPreviewId === addon.id ? null : addon.id);
                    }
                  }} className="w-14 h-14 shrink-0 border-2 border-black/40 relative group/lens" style={{
                    background: addon.gradient,
                    boxShadow: 'inset 0 0 12px rgba(0,0,0,0.4)'
                  }} aria-label={`Preview ${addon.name}`} data-id="element-496">
                        <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover/lens:opacity-100 transition-opacity bg-black/40 font-barlow text-[8px] tracking-[1px] text-white uppercase" data-id="element-497">
                          Preview
                        </span>
                      </button>
                      {/* Body */}
                      <div className="flex-grow min-w-0" data-id="element-498">
                        <div className="flex items-center gap-2 mb-1" data-id="element-499">
                          <span className="text-acid-green" data-id="element-500">{addon.icon}</span>
                          <h4 className="font-bebas text-[20px] text-white leading-none" data-id="element-501">
                            {addon.name}
                          </h4>
                        </div>
                        <div className="font-barlow text-[10px] text-acid-green tracking-[1.5px] mb-1" data-id="element-502">
                          {addon.sub} · +${addon.price} each
                        </div>
                        <p className="font-inter text-[12px] text-text-dimmed leading-snug" data-id="element-503">
                          {addon.desc}
                        </p>
                      </div>
                      {/* Quantity stepper */}
                      <div className="flex flex-col items-end gap-2 shrink-0" data-id="element-504">
                        <div className="font-bebas text-[22px] text-white leading-none" data-id="element-505">
                          {count > 0 ? `+${(count * addon.price).toFixed(2)}` : `+${addon.price}`}
                        </div>
                        <div className={`flex items-center border ${active ? 'border-acid-green' : 'border-dark-3'}`} data-id="element-506">
                          <button type="button" onClick={() => changeAddonQty(addon.id, -1)} disabled={count === 0} className="px-2 py-1 text-text-dimmed hover:text-acid-green disabled:opacity-40 disabled:hover:text-text-dimmed transition-colors" aria-label={`Decrease ${addon.name} quantity`} data-id="element-507">
                            <Minus size={14} data-id="element-508" />
                          </button>
                          <div className={`w-8 text-center font-bebas text-[18px] leading-none ${active ? 'text-acid-green' : 'text-white'}`} data-id="element-509">
                            {count}
                          </div>
                          <button type="button" onClick={() => changeAddonQty(addon.id, 1)} className="px-2 py-1 text-text-dimmed hover:text-acid-green transition-colors" aria-label={`Increase ${addon.name} quantity`} data-id="element-510">
                            <Plus size={14} data-id="element-511" />
                          </button>
                        </div>
                      </div>
                    </div>;
              })}
              </div>
            </div>

            {/* Multi-Pack Bundles */}
            <div className="mb-8" data-id="element-512">
              <div className="flex items-center gap-3 mb-2" data-id="element-513">
                <div className="font-barlow text-xs text-acid-green tracking-widest uppercase" data-id="element-514">
                  ━━ MULTI-PACK BUNDLES — STOCK UP ━━
                </div>
              </div>
              <p className="font-inter text-[12px] text-text-dimmed mb-4" data-id="element-515">
                Equip your squad. Bundle pricing replaces single-mask quantity
                above.
              </p>

              <div className="space-y-3" data-id="element-516">
                {bundles.map(bundle => {
                const checked = selectedBundle === bundle.id;
                const perUnit = (bundle.price / bundle.count).toFixed(2);
                const bundleSavings = (BASE_PRICE * bundle.count - bundle.price).toFixed(2);
                return <button key={bundle.id} onClick={() => toggleBundle(bundle.id)} className={`w-full flex items-center gap-4 p-4 border text-left transition-all relative ${checked ? 'border-acid-green bg-acid-green-dim' : 'border-dark-3 bg-dark-1 hover:border-acid-green/40'}`} data-id="element-517">
                      {bundle.badge && <div className="absolute -top-2 right-4 bg-acid-green text-black font-barlow font-bold text-[9px] tracking-[2px] px-2 py-0.5" data-id="element-518">
                          ★ {bundle.badge} ★
                        </div>}
                      {/* Mask count visual */}
                      <div className={`w-14 h-14 shrink-0 border-2 flex items-center justify-center font-bebas text-[24px] ${checked ? 'border-acid-green text-acid-green' : 'border-dark-3 text-white'}`} data-id="element-519">
                        {bundle.count}×
                      </div>
                      {/* Body */}
                      <div className="flex-grow min-w-0" data-id="element-520">
                        <div className="flex items-center gap-2 mb-1" data-id="element-521">
                          <Users size={16} className="text-acid-green" data-id="element-522" />
                          <h4 className="font-bebas text-[20px] text-white leading-none" data-id="element-523">
                            {bundle.name}
                          </h4>
                        </div>
                        <div className="font-barlow text-[11px] text-text-dimmed tracking-[1px] mb-0.5" data-id="element-524">
                          {bundle.count} MASKS · ${perUnit} EACH · SAVE $
                          {bundleSavings}
                        </div>
                        {bundle.desc && <div className="font-inter text-[10px] text-acid-green/80" data-id="element-525">
                            {bundle.desc}
                          </div>}
                      </div>
                      {/* Price + checkbox */}
                      <div className="flex flex-col items-end gap-2 shrink-0" data-id="element-526">
                        <div className="font-bebas text-[22px] text-white leading-none" data-id="element-527">
                          ${bundle.price.toFixed(2)}
                        </div>
                        <div className={`w-6 h-6 border-2 flex items-center justify-center transition-colors ${checked ? 'border-acid-green bg-acid-green' : 'border-dark-3'}`} data-id="element-528">
                          {checked && <Check size={14} className="text-black" strokeWidth={3} data-id="element-529" />}
                        </div>
                      </div>
                    </button>;
              })}
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col gap-4 mb-10" data-id="element-530">
              <Button variant="primary" fullWidth onClick={handleDeploy} data-id="element-531">
                ⚔ DEPLOY NOW — ${total.toFixed(2)}
              </Button>
              <Button variant="secondary" fullWidth onClick={handleDeploy} data-id="element-532">
                ⚡ EXPRESS CHECKOUT
              </Button>
              {(totalAddons > 0 || activeBundle) && <p className="font-inter text-[11px] text-text-dimmed text-center" data-id="element-533">
                  Includes {maskCount} mask{maskCount > 1 ? 's' : ''}
                  {activeBundle && ` (${activeBundle.name})`}
                  {totalAddons > 0 && ` + ${totalAddons} bonus lens${totalAddons > 1 ? 'es' : ''}`}
                </p>}
            </div>

            {/* Perks Grid */}
            {/* Perks Marquee — single-line infinite slider */}
            <div className="relative mb-10 border-y border-dark-3 bg-dark-1 overflow-hidden py-3" data-id="element-534">
              <div className="absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-dark-1 to-transparent z-10 pointer-events-none" data-id="element-535" />
              <div className="absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-dark-1 to-transparent z-10 pointer-events-none" data-id="element-536" />
              <motion.div className="flex gap-8 whitespace-nowrap" animate={{
              x: ['0%', '-50%']
            }} transition={{
              duration: 10,
              ease: 'linear',
              repeat: Infinity
            }} data-id="element-537">
                {[...Array(2)].flatMap((_, dup) => [{
                icon: <Truck size={14} data-id="element-538" />,
                text: 'FREE USA SHIPPING'
              }, {
                icon: <Shield size={14} data-id="element-539" />,
                text: 'LIFETIME WARRANTY'
              }, {
                icon: <RefreshCw size={14} data-id="element-540" />,
                text: '30-DAY FREE RETURNS'
              }, {
                icon: <Lock size={14} data-id="element-541" />,
                text: '256-BIT SECURE CHECKOUT'
              }, {
                icon: <Check size={14} data-id="element-542" />,
                text: 'AMERICAN BRAND'
              }, {
                icon: <Check size={14} data-id="element-543" />,
                text: 'VETERAN INSPECTED'
              }].map((perk, i) => <div key={`${dup}-${i}`} className="flex items-center gap-2 shrink-0 font-barlow font-bold text-[11px] tracking-[2px] text-text-body uppercase" data-id="element-544">
                      <span className="text-acid-green" data-id="element-545">{perk.icon}</span>
                      <span data-id="element-546">{perk.text}</span>
                      <span className="text-acid-green ml-6" data-id="element-547">◆</span>
                    </div>))}
              </motion.div>
            </div>

            {/* Interactive Tabs — Specs / Fit / Shipping */}
            <div className="border border-dark-3 bg-dark-1" data-id="element-548">
              {(() => {
              const tabs = [{
                id: 'specs',
                label: 'SPECS',
                sub: 'TECH'
              }, {
                id: 'fit',
                label: 'FIT',
                sub: 'SIZING'
              }, {
                id: 'shipping',
                label: 'SHIPPING',
                sub: 'POLICY'
              }];
              const activeTab = openAccordion || 'specs';
              return <>
                    {/* Tab triggers */}
                    <div className="grid grid-cols-3 border-b border-dark-3" data-id="element-549">
                      {tabs.map(t => {
                    const isActive = activeTab === t.id;
                    return <button key={t.id} onClick={() => setOpenAccordion(t.id)} className={`relative px-3 py-3 text-center transition-colors ${isActive ? 'text-white bg-base-black' : 'text-text-dimmed hover:text-white'}`} data-id="element-550">
                            <div className="font-barlow text-[9px] text-acid-green tracking-[2px] mb-0.5" data-id="element-551">
                              {t.sub}
                            </div>
                            <div className="font-bebas text-[16px] tracking-[2px] leading-none" data-id="element-552">
                              {t.label}
                            </div>
                            {isActive && <motion.div layoutId="tab-indicator" className="absolute bottom-0 left-0 right-0 h-[2px] bg-acid-green" data-id="element-553" />}
                          </button>;
                  })}
                    </div>

                    {/* Tab panel */}
                    <div className="p-5 min-h-[180px] relative" data-id="element-554">
                      <AnimatePresence mode="wait" data-id="element-555">
                        <motion.div key={activeTab} initial={{
                      opacity: 0,
                      y: 8
                    }} animate={{
                      opacity: 1,
                      y: 0
                    }} exit={{
                      opacity: 0,
                      y: -8
                    }} transition={{
                      duration: 0.2
                    }} data-id="element-556">
                          {activeTab === 'specs' && <div className="grid grid-cols-2 gap-x-6 gap-y-2" data-id="element-557">
                              {specs.map((s, i) => <div key={i} className="flex justify-between items-baseline border-b border-dark-3 py-1.5" data-id="element-558">
                                  <span className="font-barlow text-[10px] text-acid-green tracking-[1.5px] uppercase" data-id="element-559">
                                    {s.label}
                                  </span>
                                  <span className="font-inter text-[11px] text-white text-right" data-id="element-560">
                                    {s.value}
                                  </span>
                                </div>)}
                              <div className="col-span-2 mt-2 flex items-center gap-2 pt-2 border-t border-acid-green/20" data-id="element-561">
                                <Check size={14} className="text-acid-green" data-id="element-562" />
                                <span className="font-barlow text-[11px] text-acid-green tracking-[1px] uppercase" data-id="element-563">
                                  Includes Smoke Black Lenses (standard)
                                </span>
                              </div>
                            </div>}
                          {activeTab === 'fit' && <div className="space-y-4" data-id="element-564">
                              <div className="flex items-center gap-3 mb-2" data-id="element-565">
                                <div className="font-bebas text-[40px] text-acid-green leading-none" data-id="element-566">
                                  52–62
                                </div>
                                <div data-id="element-567">
                                  <div className="font-barlow text-[10px] text-text-dimmed tracking-[2px] uppercase" data-id="element-568">
                                    Head Circumference
                                  </div>
                                  <div className="font-bebas text-[14px] text-white tracking-[1px]" data-id="element-569">
                                    CENTIMETERS
                                  </div>
                                </div>
                              </div>
                              {/* Fit range bar */}
                              <div className="relative h-2 bg-dark-3 w-full" data-id="element-570">
                                <div className="absolute inset-y-0 left-[5%] right-[5%] bg-gradient-to-r from-acid-green/60 to-acid-green" data-id="element-571" />
                              </div>
                              <p className="font-inter text-[12px] text-text-dimmed leading-relaxed" data-id="element-572">
                                Universal fit. Dual-point ballistic nylon strap
                                + dense neoprene padding ensure secure,
                                zero-wobble wear on{' '}
                                <span className="text-white font-bold" data-id="element-573">
                                  95% of adult users
                                </span>
                                .
                              </p>
                            </div>}
                          {activeTab === 'shipping' && <div className="space-y-3" data-id="element-574">
                              {[{
                          icon: <Truck size={14} data-id="element-575" />,
                          label: 'SAME-DAY DISPATCH',
                          value: 'Orders before 2PM ET'
                        }, {
                          icon: <Check size={14} data-id="element-576" />,
                          label: 'FREE USA SHIPPING',
                          value: '3–5 day standard delivery'
                        }, {
                          icon: <RefreshCw size={14} data-id="element-577" />,
                          label: '30-DAY RETURNS',
                          value: 'Prepaid label included'
                        }].map((item, i) => <div key={i} className="flex items-center gap-3 border-b border-dark-3 pb-2 last:border-b-0" data-id="element-578">
                                  <div className="text-acid-green shrink-0" data-id="element-579">
                                    {item.icon}
                                  </div>
                                  <div className="flex-grow" data-id="element-580">
                                    <div className="font-barlow text-[10px] text-acid-green tracking-[2px] uppercase" data-id="element-581">
                                      {item.label}
                                    </div>
                                    <div className="font-inter text-[11px] text-text-dimmed" data-id="element-582">
                                      {item.value}
                                    </div>
                                  </div>
                                </div>)}
                            </div>}
                        </motion.div>
                      </AnimatePresence>
                    </div>
                  </>;
            })()}
            </div>
          </div>
        </div>
      </div>
    </section>;
};